import { IEvent } from '@/interfaces/event-log';
import { toJS } from 'mobx';
import { v4 as uuidv4 } from 'uuid';
import { lsm, ssm, StoreWithCache } from './store-manager';

const EVENT_TRACK_KEY = 'VKYC_EVENT_TRACK';
const DEVICE_ID_KEY = 'VKYC_DEVICE_ID';

interface IEventTrackStore {
  cachedEvents: IEvent[];
  eventsSent: boolean;
}

class EventTrackStore {
  private static DEFAULT_EVENT_TRACK_VALUE: IEventTrackStore = {
    cachedEvents: [],
    eventsSent: false,
  };

  private store: StoreWithCache<IEventTrackStore>;
  private idStore: StoreWithCache<string>;

  constructor() {
    this.store = ssm.getStoreWithCache(EVENT_TRACK_KEY);
    this.idStore = lsm.getStoreWithCache(DEVICE_ID_KEY);
    this.store.setDefault(() => EventTrackStore.DEFAULT_EVENT_TRACK_VALUE);
  }

  public getValue(): IEventTrackStore {
    return this.store.getNotNull();
  }

  public ifEventSent() {
    return this.getValue().eventsSent;
  }

  public getCashedEvents() {
    return this.getValue().cachedEvents;
  }

  public updateCashedEvents(events: IEvent[]) {
    this.store.setMember((v) => {
      v.cachedEvents = events;
    });
  }

  public updateEventsSent(value: boolean) {
    this.store.setMember((v) => {
      v.eventsSent = value;
    });
  }

  public getDeviceId(): string {
    let id = this.idStore.get();
    if (!id) {
      id = uuidv4();
      this.idStore.set(id);
    }
    return id;
  }

  public clearEventsData() {
    this.updateCashedEvents([]);
  }

  public clearData() {
    this.store.clear();
  }
}

const eventTrackStore = new EventTrackStore();
export default eventTrackStore;

['development', 'staging'].includes(process.env.MODE!) &&
  Object.assign(window, { eventTrackStore, toJS });
